export default __webpack_public_path__ + "static/media/avatar6.6ec1ebcb.png";